module.exports = __webpack_public_path__ + "static/media/download_qrcode.28106b6f.png";